export default __webpack_public_path__ + "static/media/lightIcon.6b95d35c.svg";